var $ = require('jquery');

module.exports = function(el, undefined) {
	$(el).find('input[type="file"]').not('.is-customized').each(function(i, el){
		var fileInput = $(el)
			.addClass('customfile-input') //add class for CSS
			.mouseover(function(){ upload.addClass('customfile-hover'); })
			.mouseout(function(){ upload.removeClass('customfile-hover'); })
			.focus(function(){
				upload.addClass('customfile-focus');
				fileInput.data('val', fileInput.val());
			})
			.blur(function(){
				upload.removeClass('customfile-focus');
				$(this).trigger('checkChange');
			 })
			 .bind('disable',function(){
				fileInput.attr('disabled',true);
				upload.addClass('customfile-disabled');
			})
			.bind('enable',function(){
				fileInput.removeAttr('disabled');
				upload.removeClass('customfile-disabled');
			})
			.bind('checkChange', function(){
				if(fileInput.val() && fileInput.val() != fileInput.data('val')){
					fileInput.trigger('change');
				}
			})
			.bind('change',function(){
				//get file name
				var fileName = $(this).val().split(/\\/).pop();
				//get file extension
				var fileExt = 'customfile-ext-' + fileName.split('.').pop().toLowerCase();
				//update the feedback
				// uploadFeedback
				uploadFeedbackLabel
					.text(fileName) //set feedback text to filename
					// .removeClass(uploadFeedback.data('fileExt') || '') //remove any existing file extension class
					// .addClass(fileExt) //add file extension class
					// .data('fileExt', fileExt) //store file extension for class removal on next change
					// .addClass('customfile-feedback-populated'); //add class to show populated state
				//change text of button
				// uploadButton.text('Change');
				// if ( $('.js-input-label-change').size() ) {
				// 	uploadButton.text($('.js-input-label-change').text());
				// }
				if ( fileName && fileName.length ) {
					upload.addClass('has-value');
				}
				else {
					upload.removeClass('has-value');
				}
			})
			.click(function(){ //for IE and Opera, make sure change fires after choosing a file, using an async callback
				fileInput.data('val', fileInput.val());
				setTimeout(function(){
					fileInput.trigger('checkChange');
				},100);
			});
			
		//create custom control container
		var upload = $('<div class="customfile"></div>');
		//create custom control button
		var uploadButton = $('<span class="customfile-button" aria-hidden="true"></span>').appendTo(upload);

		var labelcta = '';
		if ( $(el).parents('[data-js-fileinput-ctalabel]').size() ) {
			labelcta = $(el).parents('[data-js-fileinput-ctalabel]').attr('data-js-fileinput-ctalabel');
			$('<span class="customfile-button-cta">'+labelcta+'</span>').appendTo(uploadButton);
		}

		var label = '> Joindre un fichier';
		if ( $(el).parents('[data-js-fileinput-label]').size() ) {
			label = $(el).parents('[data-js-fileinput-label]').attr('data-js-fileinput-label');
		}
		$('<span class="customfile-button-label">'+label+'</span>').appendTo(uploadButton);

		if ( $('.js-input-label-browse').size() ) {
			uploadButton.text($('.js-input-label-browse').text());
		}
		//create custom control feedback
		var uploadFeedback = $('<span class="customfile-feedback" aria-hidden="true"></span>').appendTo(upload);

		var labelcta_nofile = '';
		if ( $(el).parents('[data-js-fileinput-nofile-ctalabel]').size() ) {
			labelcta_nofile = $(el).parents('[data-js-fileinput-nofile-ctalabel]').attr('data-js-fileinput-nofile-ctalabel');
			$('<span class="customfile-feedback-cta">'+labelcta_nofile+'</span>').appendTo(uploadFeedback);
		}

		var label_nofile = 'No file selected...';
		if ( $(el).parents('[data-js-fileinput-nofile-label]').size() ) {
			label_nofile = $(el).parents('[data-js-fileinput-nofile-label]').attr('data-js-fileinput-nofile-label');
		}
		var uploadFeedbackLabel = $('<span class="customfile-feedback-label">'+label_nofile+'</span>').appendTo(uploadFeedback);
		
		if ( $('.js-input-label-state').size() ) {
			uploadFeedback.text($('.js-input-label-state').text());
		}


		// var nofile_label = 'No file selected...';
		// if ( $('.js-input-label-state').size() ) {
		// 	nofile_label = $('.js-input-label-state').text();
		// }
		// if ( $(el).parents('[data-js-fileinput-nofile-label]').size() ) {
		// 	nofile_label = $(el).parents('[data-js-fileinput-nofile-label]').attr('data-js-fileinput-nofile-label');
		// }
		// var nofile_labelcta = '';
		// if ( $(el).parents('[data-js-fileinput-nofile-ctalabel]').size() ) {
		// 	nofile_labelcta = '<span class="customfile-label-cta">'+$(el).parents('[data-js-fileinput-nofile-ctalabel]').attr('data-js-fileinput-nofile-ctalabel')+'</span>';
		// }
		
		//match disabled state
		if(fileInput.is('[disabled]')){
			fileInput.trigger('disable');
		}


		//on mousemove, keep file input under the cursor to steal click
		upload
			.mousemove(function(e){
				// fileInput.css({
				// 	'left': e.pageX - upload.offset().left - fileInput.outerWidth() + 20, //position right side 20px right of cursor X)
				// 	'top': e.pageY - upload.offset().top - $(window).scrollTop() - 3
				// });
			})
			.insertAfter(fileInput); //insert after the input

		fileInput.appendTo(upload);

		$(el).addClass('is-customized');
	});
};
